// 12 priority cities served — for local SEO landing pages.
// Distances/times measured to Max Super Speciality Hospital, Mohali.

export const CITIES = [
  {
    slug: "chandigarh",
    name: "Chandigarh",
    region: "Union Territory",
    tag: "The tri-city home base",
    distance: "8 km · 20-min drive",
    lede: "Chandigarh patients form the local core of the practice — walk-in imaging review and same-week interventions are routine.",
    context:
      "For residents of Sectors 8, 17, 22, 35, and the outer sectors, Dr Sidhu's IR suite at Max Mohali is a 20-minute drive over the Sector 26 flyover. Many Chandigarh patients complete a full workup — Doppler, CT/MR, consultation, and, where indicated, day-case procedure — inside a single week.",
    transit: ["20-min drive via Madhya Marg / Airport Road", "Shared taxi from Sector 17: ~30 min", "Metro-like Sector 43 ISBT bus routes to Phase 8, Mohali"],
    commonConditions: ["varicose-veins", "peripheral-artery-disease", "uterine-fibroids", "prostate-artery-embolisation", "deep-vein-thrombosis"],
    referralNotes:
      "Second-opinion imaging review is offered to patients already under care at PGIMER, GMCH-32, or Fortis Mohali — with clinical letters written to be read by referring colleagues.",
  },
  {
    slug: "mohali",
    name: "Mohali (SAS Nagar)",
    region: "Punjab",
    tag: "The clinic's own city",
    distance: "At the clinic",
    lede: "Home city of the practice. Same-day evaluation and same-week procedures for Mohali residents are the norm, not the exception.",
    context:
      "Phase 1 through Phase 11, Aerocity, Sector 82, and the newer Sectors 90+ — all within a 15-minute radius of Max Super Speciality Hospital. Local GP referrals are read the same day; walk-in consultation slots are held for tri-city residents.",
    transit: ["Direct — the clinic is here", "Auto/taxi from anywhere in Mohali: 15-min max", "Local pickup from Aerocity, Phase 1–11 arranged on request"],
    commonConditions: ["deep-vein-thrombosis", "varicose-veins", "diabetic-foot-angioplasty", "peripheral-artery-disease", "uterine-fibroids"],
    referralNotes: "Familiar with local GP practices, Mohali Civil Hospital referrals, and neighbouring specialist clinics.",
  },
  {
    slug: "panchkula",
    name: "Panchkula",
    region: "Haryana",
    tag: "The tri-city's third",
    distance: "20 km · 35-min drive",
    lede: "Sector 5 to Sector 27, and the Pinjore–Kalka belt — Panchkula patients get the same continuity as Chandigarh and Mohali.",
    context:
      "The trip from Sector 12 or 20 Panchkula to Max Mohali runs through the tri-city expressway. For patients already under care at Alchemist, Ojas, or the local civil hospital, second-opinion review with imaging is routine.",
    transit: ["35-min drive via HUDA road → Zirakpur → Mohali", "Shared taxi from Sector 5 Panchkula: ~45 min"],
    commonConditions: ["carotid-stenting", "aortic-aneurysm", "peripheral-artery-disease", "varicose-veins", "uterine-fibroids"],
    referralNotes: "Clinical letters routinely sent back to referring Panchkula and Kalka physicians.",
  },
  {
    slug: "ludhiana",
    name: "Ludhiana",
    region: "Punjab",
    tag: "Punjab's industrial capital",
    distance: "100 km · 1 hr 45 min drive",
    lede: "The largest patient catchment in Punjab outside the tri-city — DMC, CMC, and private-hospital referrals are steady.",
    context:
      "Ludhiana's industrial and business communities skew older, with high rates of diabetes, PAD, and CAD. Many patients travel a single day for consult + Doppler + procedure planning, then return for the day-case intervention.",
    transit: ["Drive: Ludhiana → Kharar → Mohali (~1h45m via NH-44)", "Train: Ludhiana Junction → Chandigarh (2h)", "Overnight taxi options with wheelchair-friendly vehicles available"],
    commonConditions: ["peripheral-artery-disease", "diabetic-foot-angioplasty", "aortic-aneurysm", "carotid-stenting", "prostate-artery-embolisation"],
    referralNotes: "Long-standing referral relationships with DMC Ludhiana and private diabetology practices in Model Town and Sarabha Nagar.",
  },
  {
    slug: "amritsar",
    name: "Amritsar",
    region: "Punjab",
    tag: "The NRI gateway",
    distance: "230 km · 3 hr 30 min drive",
    lede: "Amritsar is often the first Indian city NRI patients land at — direct international flights from Toronto, London, and Birmingham make it a natural staging point.",
    context:
      "Many NRI families base out of Amritsar and travel to Mohali for the specialist visit. Air India, Air Canada, and IndiGo operate direct flights from GNDU Amritsar (ATQ). For local Amritsar residents, the Chandigarh–Amritsar corridor is regularly served by chauffeured medical transport.",
    transit: ["Drive: Amritsar → Jalandhar → Mohali (3h30m)", "Amritsar (ATQ) → Chandigarh (IXC) flight: 45 min", "Shatabdi train Amritsar → Chandigarh: 3h"],
    commonConditions: ["uterine-fibroids", "peripheral-artery-disease", "aortic-aneurysm", "prostate-artery-embolisation", "carotid-stenting"],
    referralNotes: "Coordinates with Amritsar-based GPs and Fortis Amritsar for imaging transfer and post-procedure follow-up.",
  },
  {
    slug: "jalandhar",
    name: "Jalandhar",
    region: "Punjab",
    tag: "The Doaba NRI hub",
    distance: "150 km · 2 hr 15 min drive",
    lede: "Jalandhar's Doaba community has the deepest overseas ties — Canada, UK, and Italy referrals often route through Jalandhar family homes.",
    context:
      "Elderly parents living in Jalandhar districts, their children abroad — this is one of Dr Sidhu's most frequent case profiles. Video consults with the overseas family + in-person work-up locally in Jalandhar is a common blend.",
    transit: ["Drive: Jalandhar → Ludhiana → Mohali (2h15m via NH-44)", "Rail: Jalandhar Cantt → Chandigarh 3h"],
    commonConditions: ["peripheral-artery-disease", "uterine-fibroids", "aortic-aneurysm", "varicose-veins", "prostate-artery-embolisation"],
    referralNotes: "Common family-based NRI coordination — imaging often sent from abroad while patient is in Jalandhar.",
  },
  {
    slug: "patiala",
    name: "Patiala",
    region: "Punjab",
    tag: "Old-city referral base",
    distance: "65 km · 1 hr 15 min drive",
    lede: "Patiala's Rajindra Hospital and Government Medical College refer complex vascular cases to Mohali regularly.",
    context:
      "Patients from Patiala, Sangrur, and the surrounding rural belt often present later than urban patients — meaning limb salvage and diabetic foot cases are common. Fast-track same-day angiography is offered where indicated.",
    transit: ["Drive: Patiala → Rajpura → Mohali (1h15m)", "Rail options via Rajpura Junction", "Shared medical taxi services from Patiala–Rajpura corridor"],
    commonConditions: ["diabetic-foot-angioplasty", "foot-salvage-cli", "peripheral-artery-disease", "aortic-aneurysm", "dialysis-access"],
    referralNotes: "Coordinates with Rajindra Hospital and Government Medical College Patiala for imaging and follow-up.",
  },
  {
    slug: "bathinda",
    name: "Bathinda",
    region: "Punjab",
    tag: "The Malwa hub",
    distance: "220 km · 3 hr 30 min drive",
    lede: "The Malwa belt — Bathinda, Mansa, Muktsar — is a high-diabetes, high-CKD region. Fistula work and limb salvage referrals are frequent.",
    context:
      "AIIMS Bathinda now handles many cases locally, but complex endovascular work and second opinions still route to Mohali. Patients often combine an overnight Chandigarh stay with a single-day work-up and consult.",
    transit: ["Drive: Bathinda → Barnala → Ludhiana → Mohali (3h30m)", "Rail: Bathinda → Chandigarh via change at Ludhiana"],
    commonConditions: ["dialysis-access", "av-fistula-salvage", "diabetic-foot-angioplasty", "peripheral-artery-disease", "foot-salvage-cli"],
    referralNotes: "Familiar with AIIMS Bathinda IR service pathways for hand-offs where appropriate.",
  },
  {
    slug: "ambala",
    name: "Ambala",
    region: "Haryana",
    tag: "The Haryana border gateway",
    distance: "50 km · 1 hr drive",
    lede: "Ambala City, Ambala Cantt, and the surrounding Haryana districts sit within a comfortable single-day round trip.",
    context:
      "Military and Railways establishments in Ambala Cantt refer selected cases when specialist IR isn't available locally. Same-day evaluation possible in most cases.",
    transit: ["Drive: Ambala → Mohali (1h via NH-44)", "Rail: Ambala Cantt Junction → Chandigarh (45 min)"],
    commonConditions: ["peripheral-artery-disease", "aortic-aneurysm", "varicose-veins", "carotid-stenting", "diabetic-foot-angioplasty"],
    referralNotes: "Familiar with Command Hospital Chandimandir and Railway Divisional Hospital Ambala pathways.",
  },
  {
    slug: "delhi-ncr",
    name: "Delhi NCR",
    region: "Delhi",
    tag: "The alternative to Delhi private hospitals",
    distance: "265 km · 4 hr drive or 45-min flight",
    lede: "For Delhi patients wanting a senior IR consultation without the private-hospital sprawl and cost, Mohali is a same-day flight destination.",
    context:
      "Delhi has excellent IR capability; the Mohali choice is usually about doctor continuity, cost transparency, and the promise that the consultant reviewing the imaging is the one doing the procedure. Many Delhi patients fly IndiGo/Vistara IXC-DEL for the video consult and return for the procedure.",
    transit: ["Flight: DEL → IXC 45 min (multiple daily)", "Drive: 4h via NH-44 expressway", "Shatabdi rail: 3h30m to Chandigarh"],
    commonConditions: ["uterine-fibroids", "prostate-artery-embolisation", "peripheral-artery-disease", "aortic-aneurysm", "y-90-radioembolisation"],
    referralNotes: "Written clinical letters and imaging discs supplied for continuity with Delhi-based physicians.",
  },
  {
    slug: "shimla",
    name: "Shimla",
    region: "Himachal Pradesh",
    tag: "Himachal's referral capital",
    distance: "115 km · 3 hr drive",
    lede: "IGMC Shimla refers complex vascular and IO cases regularly — the hill descent to Chandigarh is a standard patient journey.",
    context:
      "Shimla, Solan, and the Kullu–Manali belt patients often need altitude-aware pre-op planning. Same-day work-up on arrival and next-day procedure scheduling minimises the number of trips down the mountain.",
    transit: ["Drive: Shimla → Kalka → Zirakpur → Mohali (3h)", "Toy train Shimla → Kalka + taxi to Mohali"],
    commonConditions: ["peripheral-artery-disease", "aortic-aneurysm", "uterine-fibroids", "liver-cancer-tace", "varicose-veins"],
    referralNotes: "Common referrals from IGMC Shimla; imaging routinely transferred ahead of arrival.",
  },
  {
    slug: "jammu",
    name: "Jammu",
    region: "J&K",
    tag: "J&K's most-referred destination",
    distance: "215 km · 4 hr drive or 40-min flight",
    lede: "For patients from Jammu, Kathua, and Udhampur, Chandigarh is the closest tertiary IR centre with reliable air links.",
    context:
      "Jammu (IXJ) → Chandigarh (IXC) is a 40-min flight served daily. Many patients combine consult + investigations across two days, avoiding a second trip. Complex EVAR, PAE, and cancer IR cases are the most common referral profile.",
    transit: ["Flight: Jammu (IXJ) → Chandigarh (IXC) 40 min", "Drive: Jammu → Pathankot → Mohali (4h)", "Overnight AC taxi Jammu → Mohali via Pathankot–Jalandhar corridor"],
    commonConditions: ["aortic-aneurysm", "prostate-artery-embolisation", "liver-cancer-tace", "peripheral-artery-disease", "kidney-cancer-ablation"],
    referralNotes: "Coordinates with GMC Jammu and Fortis Jammu for imaging transfer and post-procedure follow-up.",
  },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);

// Reusable NAP block — single source of truth for schema + on-page rendering
export const CLINIC_NAP = {
  name: "Dr Tegbir Vascular — Interventional Radiology at Max Super Speciality Hospital, Mohali",
  streetAddress: "Max Super Speciality Hospital, Phase 6, Sector 56A",
  addressLocality: "Mohali",
  addressRegion: "Punjab",
  postalCode: "160055",
  addressCountry: "IN",
  telephone: "+91-96460-00444",
  email: "tegbirsidhu@gmail.com",
  latitude: 30.7089,
  longitude: 76.7108,
  openingHours: "Mo-Sa 09:00-18:00",
  url: "https://drtegbirvascular.com",
  // Google Business Profile — "Dr Tegbir Sidhu - Interventional Radiologist"
  // Canonical profile URL (from Google Business dashboard).
  gbpUrl: "https://business.google.com/n/8186627953407673304/profile?fid=11608187349080217869",
  // Public share URL — used for patient "View on Google" click-throughs (map/reviews).
  gbpShareUrl: "https://share.google/5uMOY8s6W2EyQ4E24",
  gbpName: "Dr Tegbir Sidhu - Interventional Radiologist",
};
